import {Fragment, h} from 'preact';

export default function DeviceDetails({deviceInfo}){
	return (
		<Fragment>
			{deviceInfo.data.map(row => (
				<div className="account-details__block">
					<div className="row account-details__block-head">
						<div className="col col-12 col-lg-6">
							{row.title}
						</div>
						<div className="col col-12 col-lg-6">
							{row.value} {row.additional && (
								<span className="account-details__additional">{row.additional}</span>
							)}
						</div>
					</div>
				</div>
			))}
		</Fragment>
	)
}
